export const sortingTypes = {
  by_newest: 'by_newest',
  by_oldest: 'by_oldest',
  by_highest: 'by_highest',
  by_lowest: 'by_lowest',
  by_distance: 'by_distance',
};
